import { createContext } from 'react';

export const ProductListContext = createContext({});

export const ProductListProvider = ({ children, ...props }) => {
  return <ProductListContext.Provider value={{ ...props }}>{children}</ProductListContext.Provider>;
};
